export const STORAGE_KEYS = {
  currentCulture: 'INSPIRETEC.currentCulture',
  fallbackCulture: 'INSPIRETEC.fallbackCulture',
  currentCurrency: 'INSPIRETEC.currentCurrency',
  transactionReference: 'INSPIRETEC.transactionReference',
};

// Helper function to safely get data from localStorage
export function getLocalStorage(key, defaultValue = null) {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    console.error(`Error getting localStorage key [${key}]: `, error);
    return defaultValue;
  }
}

// Helper function to safely set data in localStorage
export function setLocalStorage(key, value) {
  try {
    const item = JSON.stringify(value);
    localStorage.setItem(key, item);
  } catch (error) {
    console.error(`Error setting localStorage key [${key}]: `, error);
  }
}

// Helper function to check if a key exists in localStorage and its value matches the expected value
export function hasLocalStorageKeyAndValue(key, expectedValue) {
  try {
    const item = localStorage.getItem(key);
    return item !== null && JSON.parse(item) === expectedValue;
  } catch (error) {
    return false;
  }
}
